module.exports = __webpack_public_path__ + "img/square.8598fd87.svg";